import React, {useContext, useState, useEffect} from 'react';

import {AuthContext} from '../../context';
import {forgottenPassword, login} from '../../api/auth';
import {Button, Input, Modal, Notification, Title} from '../../components';
import {Logo} from '../../assets';

const Login = ({history}) => {
  const {dispatch, isFetching} = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [notif, setNotif] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setNotif();

    const {user, error} = await login(email, password, dispatch);
    if (error) return setNotif({type: 'error', text: error});

    const role = user.infos.role;
    !isFetching && role === 'CUSTOMER' && history.replace('/');
    !isFetching && role === 'ADMIN' && history.replace('/admin');
  };

  const handleForgottenPassword = async (e) => {
    e.preventDefault();
    setNotif();

    const {data, error} = await forgottenPassword(email);
    if (error) return setNotif({type: 'error', text: error});

    setNotif({
      type: 'success',
      text: data,
    });

    setIsOpen(false);
  };

  const handleOpenModal = () => {
    setEmail('');
    setPassword('');
    setIsOpen(true);
  };

  useEffect(() => {
    setNotif('');
    if (history.location.state)
      return setNotif({type: 'error', text: history.location.state});
  }, []);

  return (
    <div className="log-container">
      <div className="content-login">
        <div className="login-container-logo">
          <img src={Logo} alt="Sublissime" />
        </div>
        <Title text="Bienvenue sur votre tableau de bord Sublissime !" />
        <form onSubmit={handleSubmit} className="login-form">
          <Input
            label="Votre addresse e-mail"
            type="email"
            name="email"
            autoComplete="email"
            value={email}
            handleChange={(e) => setEmail(e.target.value)}
            login
            required
          />
          <Input
            label="Votre mot de passe"
            type="password"
            name="password"
            id="current-password"
            autoComplete="current-password"
            value={password}
            handleChange={(e) => setPassword(e.target.value)}
            login
            required
          />
          <Button
            type={!isOpen ? 'submit' : 'button'}
            label={isFetching ? 'Chargement' : 'Se connecter'}
            login
            disabled={isFetching}
          />
          <div className="container-forgot-password-no-account">
            <Button
              type="button"
              label="Mot de passe oublié ?"
              onClick={handleOpenModal}
              forgottenPassword
            />
          </div>
        </form>
        {notif && <Notification type={notif.type} text={notif.text} />}
        {isOpen && (
          <Modal
            closeModal={() => setIsOpen(false)}
            handleClick={handleForgottenPassword}
            buttonType={isOpen ? 'submit' : 'button'}
            title="Réinitialiser mon mot de passe par email"
            subtitle="Entrez l’adresse e-mail associée à votre compte ci-dessous."
          >
            <Input
              label="Votre addresse e-mail"
              type="email"
              name="email"
              autoComplete="email"
              value={email}
              handleChange={(e) => setEmail(e.target.value)}
              dark
              required
            />
          </Modal>
        )}
      </div>
    </div>
  );
};

export default Login;
